const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/reviews.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/reviews")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
export async function readTherapistReviewsResponse(res: Response): Promise<TherapistReview[]> {
  const body = (await res.json().catch(() => null)) as {
    items?: unknown;
    error?: unknown;
  } | null;
  if (!res.ok) {
    const message = typeof body?.error === "string" ? body.error : "Recenzije nije moguće učitati.";
    throw new Error(message);
  }
  if (!Array.isArray(body?.items)) {
    throw new Error("Recenzije nije moguće učitati.");
  }
  return body.items as TherapistReview[];
}